import React from 'react';
import styles from './UserManagement.module.css';

const FilterBar = ({ onFilterChange, departments = [], searchInputRef }) => {
  const handleSearchChange = (e) => {
    onFilterChange({ search: e.target.value });
  };

  const handleRoleChange = (e) => {
    onFilterChange({ role: e.target.value });
  };

  const handleStatusChange = (e) => {
    onFilterChange({ status: e.target.value });
  };

  const handleDepartmentChange = (e) => {
    onFilterChange({ department: e.target.value });
  };

  const handleSortChange = (e) => {
    onFilterChange({ sort: e.target.value });
  };

  return (
    <div className={styles.filterBar}>
      <div className={styles.filterGroup}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Kullanıcı ara..."
          onChange={handleSearchChange}
          ref={searchInputRef}
        />
        <select
          className={styles.select}
          onChange={handleRoleChange}
          defaultValue=""
        >
          <option value="">Tüm Roller</option>
          <option value="admin">Admin</option>
          <option value="superuser">Süper Kullanıcı</option>
          <option value="user">Normal Kullanıcı</option>
        </select>
        <select
          className={styles.select}
          onChange={handleStatusChange}
          defaultValue=""
        >
          <option value="">Tüm Durumlar</option>
          <option value="active">Aktif</option>
          <option value="inactive">Pasif</option>
        </select>
        <select
          className={styles.select}
          onChange={handleDepartmentChange}
          defaultValue=""
        >
          <option value="">Tüm Departmanlar</option>
          {departments.map(dep => (
            <option key={dep} value={dep}>{dep}</option>
          ))}
        </select>
        <select
          className={styles.select}
          onChange={handleSortChange}
          defaultValue=""
        >
          <option value="">Sırala</option>
          <option value="name">İsme Göre</option>
          <option value="role">Role Göre</option>
          <option value="createdAt">Oluşturulma Tarihi</option>
        </select>
      </div>
    </div>
  );
};

export default FilterBar; 